import React from 'react'

import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'

import { DocumentReportList } from './components/DocumentReportList'

export const DocumentReportListPage = () => {
  useLogEventOnMount('Access to document lists')

  return <DocumentReportList />
}
